import Button from "@mui/material/Button";
import { deleteNotification } from "api/layer";
import Modal from "components/modal/modal";
import { AppAction, AppContext } from "helpers/context";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import styles from "./delete-message-modal.module.scss";
import { MessageType } from "../type";

interface Props {
  data: MessageType;
  initData: () => void;
  onClose: () => void;
}

const DeleteMessageModal: React.FC<Props> = ({ data, initData, onClose }) => {
  const [t] = useTranslation();
  const [context, dispatch] = useContext(AppContext);

  const confirmDeleteMessage = (): void => {
    deleteNotification(data.notificationId)
      .then((resp: any) => {
        if (!resp || resp.code !== 200) {
          dispatch({
            type: AppAction.addSnackBarParams,
            payload: {
              title: "deleteNotification",
              titleIconColor: "yellow",
              titleIcon: "warning",
              resMessage: resp.message,
            },
          });
          return;
        }
        dispatch({
          type: AppAction.addSnackBarParams,
          payload: {
            title: "deleteNotification",
            message: "deleteNotificationSuccess",
          },
        });
      })
      .catch((error: any) => {
        console.error(error);
        dispatch({
          type: AppAction.addSnackBarParams,
          payload: {
            title: "deleteNotification",
            titleIconColor: "red",
            titleIcon: "error",
            message: "deleteNotificationError",
          },
        });
      })
      .finally(() => {
        initData();
        onClose();
      });
  };

  return (
    <Modal
      header={t("userSystem.deleteMessage.title")}
      opened={!!data.notificationId}
      onClose={onClose}
    >
      <div className={styles.info}>
        <div className={styles.text}>{`${t("userSystem.deleteMessage.prefix")}${
          data.notificationMessage
        }${t("userSystem.deleteMessage.suffix")}`}</div>

        <div className={styles.button}>
          <Button
            variant="text"
            color="success"
            onClick={onClose}
            style={{ outline: "none" }}
          >
            {t("buttons.cancel")}
          </Button>
          &nbsp;&nbsp;
          <Button
            variant="contained"
            color="error"
            onClick={confirmDeleteMessage}
          >
            {t("buttons.delete")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteMessageModal;
